import { getMessageHistory } from '@/api/chat'
import { scrollTo } from '@/utils/dom'

export default {
    data () {
        return {
            disconnectTimestamp: 0,
        }
    },
    methods: {
        getTheLastMessageServerTimestamp () {
            if (this.getMessageLength() === 0) {
                return
            }
            for (let i = this.getMessageLength() - 1; i >= 0; i--) {
                const timestampFromServer = this.getMessageValueByIndex(i, 'server.timestamp')
                if (timestampFromServer) {
                    return timestampFromServer
                }
            }
            return
        },
        async getBeforeReconnectMessageList () {
            try {
                let theLastMessageId = null
                const messageLength = this.getMessageLength()
                if (messageLength !== 0) {
                    theLastMessageId = this.getMessageValueByIndex(messageLength - 1, 'id')
                }
                /**
                 * 消息列表按 created_at 逆序，即第 0 个离现在最近
                 */
                const { list, pagination } = await getMessageHistory({
                    uid: this.uid,
                    startTime: this.getTheLastMessageServerTimestamp(),
                    pageNum: 1,
                    pageSize: 100
                })
                const { total_count: totalCount } = pagination

                /**
                 * 断线期间，缺失的消息数量大于 100 条，则重置聊天
                 */
                if (totalCount > list.length) {
                    this.reset()
                    return
                }

                const messageListSegment = this.generateMessageListSegment(
                    this.filterExistMessage(list)
                )
                if (messageListSegment.length > 0) {
                    if (theLastMessageId === null
                        || typeof theLastMessageId === 'undefined') {
                        this.insertMessageSegmentByIndex(messageLength, messageListSegment)
                    } else {
                        this.insertMessageSegmentById(theLastMessageId, messageListSegment)
                    }
                    this.$nextTick(() => {
                        scrollTo(this.$refs.messageList.$el, 0, 'scrollHeight')
                    })
                }
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
            }
        }
    }
}
